import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MtnaFocusDirectivesModule, MtnaInlineEditorModule } from '@mtna/core-angular';

import { RdsGetFormArrayControlPipeModule } from '../core/pipes';
import { RdsCodesTableComponent } from './codes-table.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatListModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MtnaFocusDirectivesModule,
    MtnaInlineEditorModule,
    RdsGetFormArrayControlPipeModule,
  ],
  declarations: [RdsCodesTableComponent],
  exports: [RdsCodesTableComponent],
})
export class RdsCodesTableModule {}

export * from './codes-table.component';
